
  <!--
 * 电脑端
 * @LastEditTime: Thu Sep 19 2024 16:44:01 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_GUDU16" :class="[curLang]" class="u_r_GUDU16 route-index"  @click="u_r_GUDU16_event_03N024($event)"><div id="u_c_IRUE17"  :class="[`normal`,`u_c_IRUE17`]" ><u_c_B0FU17></u_c_B0FU17><u_c_088G17></u_c_088G17><u_c_64ZR19></u_c_64ZR19><u_c_HGOL20></u_c_HGOL20><u_c_UBW523></u_c_UBW523><u_c_WD0A18></u_c_WD0A18><u_c_9B8817></u_c_9B8817><u_c_S9FT18></u_c_S9FT18><u_c_G8FJ31></u_c_G8FJ31><u_c_M6Z819></u_c_M6Z819><u_c_K9XL38></u_c_K9XL38><u_c_8EC520></u_c_8EC520><u_c_QWCE17></u_c_QWCE17></div><u_c_QIH017></u_c_QIH017><u_c_V2QT17></u_c_V2QT17></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_B0FU17 from "@/components/u_c_B0FU17.vue";import u_c_UBW523 from "@/components/u_c_UBW523.vue";import u_c_WD0A18 from "@/components/u_c_WD0A18.vue";import u_c_9B8817 from "@/components/u_c_9B8817.vue";import u_c_QIH017 from "@/components/u_c_QIH017.vue";import u_c_V2QT17 from "@/components/u_c_V2QT17.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"en-US":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['en-US']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    if(utils.isMobileType() && router.hasRoute('m')){
router.gotoRouter("/m")
};
      // 电脑端的click事件
      const u_r_GUDU16_event_03N024= async (e)=>{
        try {
try{
let videoElement = document.getElementsByTagName("video")[0];
if(videoElement){
videoElement.muted = false;
}
}catch(e){}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>
#app {
  height: 100%;
  width: 100%;
}

body,
html {
  height: auto !important;
}

@keyframes btn-breathe {
  0% {
    transform: scale(1) translateX(-50%);
  }

  50% {
    transform: scale(1.2) translateX(-50%)
  }

  100% {

    transform: scale(1) translateX(-50%)
  }
}#app {
  height: 100%;
  width: 100%;
}

body,
html {
  height: auto !important;
}

@keyframes btn-breathe {
  0% {
    transform: scale(1) translateX(-50%);
  }

  50% {
    transform: scale(1.2) translateX(-50%)
  }

  100% {

    transform: scale(1) translateX(-50%)
  }
}
.u_c_IRUE17.normal{
position:relative;
width:100%;
height:100%;
display:flex;
justify-content:center;
align-items:center;
overflow:hidden;

}

</style>
